import { CypherMD_Text, Neutral } from "./paletteConstants";

const palette = {
  neutral: Neutral,
  text: CypherMD_Text,
};

export { palette };
